import { doc, updateDoc } from "firebase/firestore";
import React, { useEffect, useRef, useState } from "react";
import db from "../firebase/fireInit";
import { saveFocus } from "../firebase/playerFuncs";
import Checkmark from "../misc/elements/Checkmark";
import MainStore from "../stores/MainStore";

const ActiveFocus = () => {
  const { player } = MainStore();
  const [activeThing, setActiveThing] = useState("");
  const inputRef = useRef(null);
  const [showInput, setShowInput] = useState(false);

  function onChecked() {
    saveFocus(player, activeThing);
    setActiveThing("");
    setShowInput(false);
  }

  function onEnterFunc(e) {
    if (e.key == "Enter") {
      saveFocus(player, activeThing);
      setActiveThing("");
      setShowInput(false);
    }
  }

  useEffect(() => {
    if (showInput) inputRef.current.focus();
  }, [showInput]);

  return (
    <div
      className="divColumn"
      style={{
        backgroundColor: "#282828",
        width: "200px",
        borderRadius: "1rem/1rem",
      }}
    >
      <div className="textBlack" style={{ color: "gold" }}>
        Focused on
      </div>
      {showInput && (
        <div className="divRow">
          <input
            onKeyDown={onEnterFunc}
            ref={inputRef}
            value={activeThing}
            onChange={(e) => {
              setActiveThing(e.target.value);
            }}
            style={{
              backgroundColor: "black",
              color: "white",
              textAlign: "center",
            }}
          />
          <Checkmark onChecked={onChecked} />
        </div>
      )}
      {!showInput && (
        <div
          className="divRow"
          style={{ cursor: "pointer", justifyContent: "center" }}
          onClick={() => {
            setShowInput(true);
          }}
        >
          <div className="textBoldWhite" style={{ textAlign: "center" }}>
            {player?.active.focus?.id ? player?.active.focus?.id : ""}
          </div>
          <img src="/icons/icon_focus.png" className="icon25" />
        </div>
      )}
    </div>
  );
};

export default ActiveFocus;
